export default __webpack_public_path__ + "static/media/classaa.2bec94b7.png";